import { axiosInstance } from "./axiosInstance";

export async function sendOTP(loginData: any, url: any): Promise<any> {

  try {
    const response = await axiosInstance.post("/send-otp", {
      loginData,
      url,
    });

    // Manually parse the response if it's a JSON string
    const responseData =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    // If request is successful, return the responseData
    if (responseData.status) {
      return responseData;
    }

    // If request failed, throw an error with the encrypted payload
    throw new Error(responseData.message || "Failed to send OTP");
  } catch (error: any) {
    if (error.response?.data?.rawError) {
      try {
        // Extract and return the encrypted payload
        const parsedError = JSON.parse(error.response.data.rawError);
        const encryptedPayload = parsedError.payload;
        return { encryptedPayload };
      } catch (decryptError) {
        return "Somewhere went wrong.";
      }
    }
    throw new Error(error.response?.data?.message || "Failed to send OTP");
  }
}

export async function verifyOTP(verifyOTPData: any, url: any) {
  try {
    const response = await axiosInstance.post("/verify-otp", {
      verifyOTPData,
      url,
    });

    // Manually parse the data if it's a JSON string
    const responseData =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    // Check if the response indicates success
    if (!responseData.status) {
      throw new Error(responseData.message || "Failed to Verify OTP");
    }
    // Return the successful response
    return responseData;
  } catch (error: any) {
    if (error.response?.data?.rawError) {
      try {
        // Extract and return the encrypted payload
        const parsedError = JSON.parse(error.response.data.rawError);
        const encryptedPayload = parsedError.payload;
        return { encryptedPayload };
      } catch (decryptError) {
        return "Somewhere went wrong.";
      }
    }
    throw new Error(error.response?.data?.message || "Failed to send OTP");
  }
}

// VERIFY CORPORATE OTP  FOR SIGNUP
export async function verifyCorporateOTP(data: {
  mobile_number: string;
  skipMobileNumber: boolean;
  isApp: boolean;
  type: string;
  otp: string;
  gstData: {
    dateOfBirth: string | undefined;
    gstMobile: string | undefined;
    name: string;
    email: string;
    gstNumber: string | undefined;
    legalName: string | undefined;
    pan: string | undefined;
    tradeName: string | undefined;
  };
}) {
  try {
    const response = await axiosInstance.post("/verify-corporate-otp", {
      data,
    });

    // Manually parse the data if it's a JSON string
    const responseData =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    // Check if the response indicates success
    if (!responseData.status) {
      throw new Error(responseData.message || "Failed to Verify OTP");
    }
    // Return the successful response
    return responseData;
  } catch (error: any) {
    if (error.response?.data?.rawError) {
      try {
        // Extract and return the encrypted payload
        const parsedError = JSON.parse(error.response.data.rawError);
        const encryptedPayload = parsedError.payload;

        return { encryptedPayload };
      } catch (decryptError) {
        return "Somewhere went wrong.";
      }
    }
    throw new Error(error.response?.data?.message || "Failed to send OTP");
  }
}
